var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "60%",
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("storage::commodity-stocks::stock_flow")) + " "
        ),
      ]),
      _c(
        "el-form",
        [
          _c("el-form-item", { attrs: { label: "SPU:" } }, [
            _vm._v(" " + _vm._s(_vm.sku.spu) + " "),
          ]),
          _c("el-form-item", { attrs: { label: "SKU:" } }, [
            _vm._v(" " + _vm._s(_vm.sku.sku) + " "),
          ]),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "storage::commodity-stocks::stock_flow_product_name"
                ),
              },
            },
            [_vm._v(" " + _vm._s(_vm.sku.productName) + " ")]
          ),
        ],
        1
      ),
      _c("z-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: {
          columns: _vm.tableColumns,
          data: _vm.tableData,
          "max-height": 300,
          pagination: _vm.pagination,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
          "page-change": _vm.handlePageChange,
        },
        scopedSlots: _vm._u([
          {
            key: "changeValue",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("span", { style: "color:" + _vm.compareCount(row.type) }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        (row.type === "1" ? "+" : "-") +
                          _vm.$dataCheck(row.changeValue, "--")
                      ) +
                      " "
                  ),
                ]),
              ]
            },
          },
          {
            key: "changeTime",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("span", [
                  _vm._v(" " + _vm._s(_vm.getDate(row.changeTime)) + " "),
                ]),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "medium" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("storage::commodity-stocks::stock_flow_close")
                  ) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }